<div flex-align="center" layout="row" class="margin-bottom-10">

	<div flex="fill" [ngClass]="[
			styles.header,
			styles.mobileHeaderItem,
			header ? '' : 'xs-hide'
		]" [innerHTML]="'<' + headerTag + '>' + escape(header) + '</' + headerTag + '>'">
	</div>

	<ng-container [hidden]="!headerTemplate" *ngTemplateOutlet="headerTemplate">
	</ng-container>

	<vb-ui-search-input #searchInputNgModel="ngModel" name="gridSearch" flex="1" [(ngModel)]="searchInputValue" [ngClass]="[styles.search, styles.mobileHeaderItem]" [placeholder]="'Event_RealTimeAnalytics_Grid_Search' | translate">
	</vb-ui-search-input>

	<button *ngIf="pollingIntervalSecs" type="button" vbBtnWhite [ngClass]="[
			styles.pauseResumeBtn,
			styles.mobileHeaderItem,
			grid.isPollingActive ? styles.pauseBtn : styles.resumeBtn
		]" (click)="grid.isPollingActive ? grid.pausePolling() : grid.resumePolling()">

		<span class="glyphicons" [ngClass]="[
				styles.pauseResumeIcon,
				grid.isPollingActive ? 'pause' : 'play'
			]">
		</span>

		{{ (grid.isPollingActive ? 'Event_RealTimeAnalytics_Grid_PauseUpdates' : 'Event_RealTimeAnalytics_Grid_ResumeUpdates') | translate }}
	</button>

</div>

<ng-content></ng-content>
